module.exports = __webpack_public_path__ + "static/img/title_bg.b9e332de.png";